import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/sharp-solid-svg-icons';
import React from 'react';
import { twMerge } from 'tailwind-merge';

type Props = {
  src: string;
  onClick?: () => void;
  className?: string;
  active?: boolean;
  checkMark?: boolean;
};

const CustomizeMediaPreview: React.FC<Props> = ({
  src,
  className = undefined,
  onClick = undefined,
  active = false,
  checkMark = false,
}) => {
  return (
    <button
      className={twMerge(
        'relative flex items-center justify-center bg-gray-10 p-[2px]',
        'outline-2 outline-offset-[-2px] outline-green-50',
        active && 'bg-gray-20 outline',
        'hover:bg-gray-20 hover:outline',
        className
      )}
      type="button"
      onClick={onClick}
      onDoubleClick={() => window.open(src, '_blank')}
    >
      <object
        className="content-fit pointer-events-none max-h-full max-w-full object-contain"
        data={src}
      >
        {src}
      </object>

      {checkMark && (
        <div className="absolute right-[2px] top-[2px] text-green-50">
          <FontAwesomeIcon icon={faCheck} />
        </div>
      )}
    </button>
  );
};

export default CustomizeMediaPreview;
